import { render, staticRenderFns } from "./TableSort.vue?vue&type=template&id=5cdaa2f9"
import script from "./TableSort.vue?vue&type=script&lang=ts"
export * from "./TableSort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports